'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _helpers = require('../../helpers');

var _formFields = require('../form-fields');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginForm = (0, _reduxForm.reduxForm)({ form: 'login' })(function (props) {
  var handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      login = props.login;


  return _react2.default.createElement(
    'form',
    { onSubmit: handleSubmit(login) },
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required],
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'you@example.com',
      autoComplete: 'email'
    }),
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required],
      name: 'password',
      label: 'Password',
      type: 'password',
      placeholder: 'Enter Password',
      autoComplete: 'current-password'
    }),
    _react2.default.createElement('input', {
      type: 'submit',
      value: 'Login',
      disabled: submitting,
      className: 'button w-button ' + (submitting ? 'disabled-btn' : '')
    })
  );
});

exports.default = LoginForm;